// How fast an online red missile flies (see power-up-renderer.js, "RED homing
// missiles"). Core's missile pursues at RED_MISSILE_SPEED on the game clock, and
// online the victim is drawn on its OWN render clock, so the flight that lands on
// time is "core's speed, on the victim's clock". Stepping by that clock directly is
// exact but stutters: an opponent's clock holds and catches up all the time. So the
// missile moves on the view's steady clock, and its SPEED (a multiple of core's)
// does the timekeeping:
//   - it follows the victim's clock SMOOTHLY: `behind` is how much victim-clock time
//     the flight still owes (clock elapsed since launch, minus flight time flown);
//     owing speeds it up a little, being ahead eases it off,
//   - once the landing moment is known (the effect's spawn event) it is exact: the
//     speed that covers the distance left in the time left; overdue = MAX,
//   - always within [MIN, MAX] and eased, so a correction is a lean, never a jump.
// Pure, so the flight can be checked without a canvas.
export var MISSILE_SPEED_MIN = 0.4;
export var MISSILE_SPEED_MAX = 3;
export var MISSILE_SPEED_EASE = 12; // per second, share of the gap to the wanted speed closed
export var MISSILE_FOLLOW_GAIN = 4; // per second: 100ms owed = 40% faster

// speed: the current multiple. landTime: game time of the landing, or undefined.
// clock: the victim's render clock. distLeft: px still to cover before the hit.
// nominal: core's speed in px per second. dt: view seconds since the last frame.
// behind: victim-clock seconds the flight owes (negative = ahead).
export function nextMissileSpeed(speed, landTime, clock, distLeft, nominal, dt, behind) {
    var want = 1 + MISSILE_FOLLOW_GAIN * (behind || 0);
    if (landTime !== undefined) {
        var left = landTime - clock;
        want = left > 0.001 ? (Math.max(0, distLeft) / nominal) / left : MISSILE_SPEED_MAX;
    }
    want = Math.max(MISSILE_SPEED_MIN, Math.min(MISSILE_SPEED_MAX, want));
    return speed + (want - speed) * Math.min(1, MISSILE_SPEED_EASE * dt);
}
